import Form from "react-bootstrap/Form";
import React, { useRef, useState } from "react";
import { Alert, Button, Col, Row } from "react-bootstrap";
import { uploadModel } from "../services/UploadModelService";
import { useTranslation } from "react-i18next";
import "../styles/Forms.css";
function UploadModel() {
    const [t, i18n] = useTranslation("global");
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [pipelineSend, setPipelineSend] = useState<Pipeline | null>(null);
    const [fileError, setFileError] = useState(false);
    const [validated, setValidated] = useState(false);
    const modelTypeRef = useRef<HTMLSelectElement>(null);
    const modelRef = useRef<HTMLSelectElement>(null);
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setPipelineSend(null);
        if (file && file.name.toLowerCase().endsWith(".sav")) {
            setSelectedFile(file);
            setFileError(false);
        } else {
            setSelectedFile(null);
            setFileError(true);
        }
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const payload = Object.fromEntries(formData);

        await uploadModel(selectedFile, payload.modelType.toString()).then(
            (pipeline: Pipeline) => {
                console.log(pipeline);
                setPipelineSend(pipeline);
                setSelectedFile(null);
                setValidated(false);
                if (modelTypeRef.current) {
                    modelTypeRef.current.value = "";
                }

                if (modelRef.current) {
                    modelRef.current.value = "";
                }
            }
        );
    };

    return (
        <>
            <div className="d-flex justify-content-center mt-5">
                <Form
                    className="w-75"
                    validated={validated}
                    onSubmit={handleSubmit}
                >
                    <Row>
                        <Col xs={12}>
                            <Form.Group
                                className="mb-3"
                                controlId="formTypeModel"
                            >
                                {pipelineSend !== null && (
                                    <Alert variant="success">
                                        {t("upload.message")}
                                        {pipelineSend.pipeline_name}
                                    </Alert>
                                )}

                                <Form.Label>{t("upload.type")}</Form.Label>
                                <Form.Select
                                    name="modelType"
                                    ref={modelTypeRef}
                                    required
                                >
                                    <option>
                                        {t("upload.placeholder-pipeline")}
                                    </option>
                                    <option value="PIPELINE_POSITIVE">
                                        {t("upload.panss-p")}
                                    </option>
                                    <option value="PIPELINE_POSITIVE_EXPLAIN">
                                        {t("upload.panss-p-explain")}
                                    </option>
                                    <option value="PIPELINE_DEL_ARTIFICIAL">
                                        {t("upload.del-artificial")}
                                    </option>
                                    <option value="PIPELINE_DEL_ARTIFICIAL_EXPLAIN">
                                        {t("upload.del-artificial-explain")}
                                    </option>
                                    <option value="PIPELINE_PSYRATSHAL">
                                        {t("upload.psyrats-hal")}
                                    </option>
                                    <option value="PIPELINE_PSYRATSHAL_EXPLAIN">
                                        {t("upload.psyrats-hal-explain")}
                                    </option>
                                    <option value="PIPELINE_PSYRATSDEL">
                                        {t("upload.psyrats-del")}
                                    </option>
                                    <option value="PIPELINE_PSYRATSDEL_EXPLAIN">
                                        {t("upload.psyrats-del-explain")}
                                    </option>
                                    <option value="PIPELINE_ROSENTOTAL">
                                        {t("upload.rosen-total")}
                                    </option>
                                    <option value="PIPELINE_ROSENTOTAL_EXPLAIN">
                                        {t("upload.rosen-total-explain")}
                                    </option>
                                    <option value="PIPELINE_BCISREFLEX">
                                        {t("upload.bcis-reflex")}
                                    </option>
                                    <option value="PIPELINE_BCISREFLEX_EXPLAIN">
                                        {t("upload.bcis-reflex-explain")}
                                    </option>
                                    <option value="PIPELINE_BCISCERTEZ">
                                        {t("upload.bcis-certez")}
                                    </option>
                                    <option value="PIPELINE_BCISCERTEZ_EXPLAIN">
                                        {t("upload.bcis-certez-explain")}
                                    </option>
                                    <option value="PIPELINE_MTC_COMPLETION">
                                        {t("upload.mct-comp")}
                                    </option>
                                    <option value="PIPELINE_MTC_COMPLETION_EXPLAIN">
                                        {t("upload.mct-comp-explain")}
                                    </option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group controlId="formFile" className="mb-3">
                        <Form.Label>{t("upload.label")}</Form.Label>
                        <Form.Control
                            ref={modelRef}
                            type="file"
                            required
                            isInvalid={
                                fileError || (validated && !selectedFile)
                            }
                            onChange={handleFileChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            {fileError
                                ? t("upload.error.extension")
                                : t("upload.error.required")}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Button
                        className="custom-button w-100"
                        variant="primary"
                        type="submit"
                    >
                        {t("buttons.submit")}
                    </Button>
                </Form>
            </div>
        </>
    );
}
export default UploadModel;
